import { Card } from '../components/ui/Card';
import { TechSelector } from '../components/ui/TechSelector';
import { Checkbox, Button } from '@crazyegginc/hatch';

import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';
import { useEffect, useState } from 'react';

import { useMutation, useNotifications } from '/src/hooks';
import { initializeSegmentIntegrationMutation } from '/src/features/installation/mutations';
import { useLocation } from 'react-router-dom';

export function SegmentInstructions({ techOptions = [], selectedTechOption = null, onSelectTech }) {
  const [installed, setInstalled] = useState(false);
  const location = useLocation();
  const notifications = useNotifications();

  const initSegment = useMutation(initializeSegmentIntegrationMutation);

  useEffect(() => {
    if (!initSegment.error) {
      return;
    }

    notifications.error({
      content: initSegment.error?.graphQLErrors?.[0]?.message || 'Segment connection failed.',
      timeout: 3000,
      context: { error: initSegment.error },
    });
  }, [initSegment.error, notifications]);

  function connectSegment() {
    initSegment.mutate(
      {
        returnUrl: `${window.location.origin}/onboarding/check-install${location.search}`,
      },
      {
        onSuccess: (data) => {
          if (data?.initializeSegmentIntegration?.redirectUrl) {
            window.open(data.initializeSegmentIntegration.redirectUrl, '_self');
          }
        },
      },
    );
  }

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <p className="text-sm sm:text-base font-normal leading-6 text-black-pearl-500">
        If you&apos;re a Segment customer, you know how easy it is to launch new integrations. Crazy Egg and Segment
        works the same way, one click with no code required.
      </p>

      <div className="my-5 rounded bg-white-lilac-500 px-6 py-5 w-full flex flex-col items-center">
        <div className="text-sm font-normal leading-5 text-black-pearl-500">
          <Checkbox
            name="already_set"
            checked={installed}
            onChange={() => setInstalled(!installed)}
            label={
              <span className="whitespace-nowrap text-black-pearl-500">I&apos;ve set up Segment for my website</span>
            }
            id="segment_installed"
          />
        </div>
        <Button
          disabled={!installed || initSegment.isPending}
          onClick={connectSegment}
          className="mt-[14px] h-[45px] rounded px-5 py-[14px] text-base font-bold leading-6"
        >
          {initSegment.isPending ? 'Connecting...' : 'Connect Segment'}
        </Button>
      </div>

      <div className="flex flex-col gap-1">
        <SupportLink
          href={SupportLinks.install.segment}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Segment Setup Guide
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>
    </Card>
  );
}
